<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full"
      :footer="false">
    <template #header>
      {{(shipment.shipmentId || shipmentId) | defaultShow}}
      <gj-tag v-if="shipment.status" type="plain" shape="rectangle"
              :color="shipment.status | optionColor(FbaShipmentEnum.statusOption)">
        {{shipment.status | optionText(FbaShipmentEnum.statusOption)}}
      </gj-tag>
    </template>
    <template #content>
      <div>
        <div v-loading="baseLoading">
          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">仓库：</span>
              <gj-tooltip :content="shipment.warehouseName" :text-line="1">
                {{shipment.warehouseName | defaultShow}}
              </gj-tooltip>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">货件名称：</span>
              <gj-tooltip
                  :text-line="1"
                  :content="shipment.name"
                  block>
                {{shipment.name | defaultShow}}
              </gj-tooltip>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">贴标方：</span>
              <span>{{shipment.labelPrepType | optionText(FbaShipmentEnum.list_labelPrepTypeOption) | defaultShow}}</span>
            </div>
          </div>

          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">包装类型：</span>
              <span>{{shipment.areCasesRequired | optionText(FbaShipmentEnum.areCasesRequiredOption) | defaultShow}}</span>
            </div>
            <div class="gj-content content_flex2 right-shift_30">
              <span class="gj-label">亚马逊仓代码：</span>
              <span>{{shipment.centerId | defaultShow}}</span>
            </div>
          </div>

          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">产品种类：</span>
              <span>{{shipment.mskuSpecies | defaultShow}}</span>
            </div>
            <div class="gj-content content_flex2 right-shift_30">
              <span class="gj-label">配送地址：</span>
              <gj-tooltip :text-line="1" :content="shipToAddress" block>{{shipToAddress}}</gj-tooltip>
            </div>
          </div>

          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">申报量：</span>
              <span>{{shipment.quantityShipped | defaultShow}}</span>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">收货量：</span>
              <span>{{shipment.quantityReceived | defaultShow}}</span>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">申收差异：</span>
              <span>{{shipment.diffValue | defaultShow}}</span>
            </div>
          </div>

          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">开始收货日期：</span>
              <span>{{shipment.receivingTime | defaultShow}}</span>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">创建时间：</span>
              <span>{{shipment.createTime | defaultShow}}</span>
            </div>
            <div class="gj-content right-shift_30">
              <span class="gj-label">更新时间：</span>
              <span>{{shipment.updateTime | defaultShow}}</span>
            </div>
          </div>

          <div class="content-row" v-if="isMeaningful(shipment.fbaPackageFileId)">
            <div class="gj-content">
              <span class="gj-label">装箱明细附件：</span>
              <gj-link
                  @click="viewFbaPackage(shipment.fbaPackageFileId)">
                <span style="font-size: 14px;">{{shipment.fbaPackageFileName}}</span>
                <i v-if="fbaPackageFileDownloadLoading" class="el-icon-loading" style="line-height: unset;"></i>
              </gj-link>
            </div>
          </div>
          <div class="content-row">
            <div class="gj-content">
              <span class="gj-label">发货地址：</span>
              <gj-tooltip :text-line="1" :content="shipFromAddress" block>{{shipFromAddress}}</gj-tooltip>
            </div>
          </div>
        </div>
        <el-tabs
            :value="'1'"
            style="margin-top: 4px;"
            @tab-click="handleClick">
          <el-tab-pane label="产品明细" name="1">
            <gj-table
                name="shipmentProduct"
                :loading="shipmentItemLoading"
                :data="shipmentItems"
                :columns="shipmentItemColumns"
                :show-overflow="false"
                >
              <template v-slot:header:quantityReceived>
                <span class="gj-mr20">收货量</span>
              </template>
              <template v-slot:sku="{row}">
                <div>{{row.sku | defaultShow}}</div>
                <gj-tooltip
                    :text-line="1"
                    :content="row.skuName">
                  {{row.skuName | defaultShow}}
                </gj-tooltip>
              </template>
              <template v-slot:msku="{row}">
                <div>{{row.msku | defaultShow}}</div>
                <div>{{row.asin | defaultShow}}</div>
                <div>{{row.fnsku | defaultShow}}</div>
              </template>
              <template v-slot:quantityReceived="{row}">
                <span class="gj-mr20">{{row.quantityReceived | defaultShow}}</span>
              </template>
            </gj-table>
          </el-tab-pane>
          <el-tab-pane label="已接收库存" name="2">
            <gj-table
                name="shipmentReceived"
                :loading="inventoryReceiptsLoading"
                :data="inventoryReceipts"
                :columns="inventoryReceiptsColumns"
                :show-overflow="false"
                >
              <template v-slot:header:quantity>
                <span class="gj-mr20">数量</span>
              </template>
              <template v-slot:sku="{row}">
                <div>{{row.sku | defaultShow}}</div>
                <gj-tooltip
                    :text-line="1"
                    :content="row.skuName">
                  {{row.skuName | defaultShow}}
                </gj-tooltip>
              </template>
              <template v-slot:productName="{row}">
                <gj-tooltip
                    :text-line="2"
                    :content="row.productName">
                  {{row.productName | defaultShow}}
                </gj-tooltip>
              </template>
              <template v-slot:msku="{row}">
                <div>{{row.msku | defaultShow}}</div>
                <div>{{row.asin | defaultShow}}</div>
                <div>{{row.fnsku | defaultShow}}</div>
              </template>
              <template v-slot:quantity="{row}">
                <span class="gj-mr20">{{row.quantity | defaultShow}}</span>
              </template>
            </gj-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </gj-modal>
</template>

<script>

  import {isMeaningfulMixin, modalMixIn} from "../../../../minxins";
  import {getFbaShipmentItems, getFbaShipment, getInventoryReceipts} from "../../../../api/logistics";
  import {FbaShipmentEnum} from "./enum";
  import {fbaShipmentAddressMixin} from "./mixin";
  import {downloadAttFile} from "../../../../api/common";

  export default {
    name: "app-view-fba-shipment-modal",
    mixins: [modalMixIn, fbaShipmentAddressMixin, isMeaningfulMixin],
    props: {
      id: {
        required: true
      },
      warehouseId: {
        required: true
      },
      shipmentId: {
        required: true
      }
    },
    data() {
      return {
        baseLoading: true,
        shipmentItemLoading: true,
        shipmentItems: [],
        inventoryReceiptsLoading: true,
        inventoryReceipts: [],
        shipmentItemColumns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'sku', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/ASIN/FNSKU', field: 'slot:msku', minWidth: '150px'},
          {id: 'quantityShipped', header: '申报量', field: 'quantityShipped', width: '120px', align: 'right'},
          {id: 'quantityReceived', header: 'slot:quantityReceived', field: 'slot:quantityReceived', width: '120px', align: 'right'},
          {id: 'receivingTime', header: '开始收货日期', field: 'receivingTime', width: '130px'},
        ],
        inventoryReceiptsColumns: [
          {id: 'receivedDate', header: '收货时间', field: 'receivedDate', width: '180px'},
          {id: 'pekingReceivedDate', header: '收货时间(北京时间)', field: 'pekingReceivedDate', width: '160px'},
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '60px'},
          {id: 'productName', header: '商品标题', field: 'slot:productName', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/ASIN/FNSKU', field: 'slot:msku', minWidth: '150px'},
          {id: 'quantity', header: 'slot:quantity', field: 'slot:quantity', width: '90px', align: 'right'},
          {id: 'centerId', header: '亚马逊仓代码', field: 'centerId', width: '100px'}
        ],
        FbaShipmentEnum: FbaShipmentEnum,
        fbaPackageFileDownloadLoading: false
      };
    },
    created() {
      this.baseLoading = true;
      getFbaShipment(this.id)
        .then((data) => {
          this.shipment = data || {};
        })
        .complete(() => this.baseLoading = false);
      // 获取货件产品明细
      this.shipmentItemLoading = true;
      getFbaShipmentItems({
        fid: this.id,
      })
        .then((data) => {
          this.shipmentItems = data;
        })
        .complete(() => this.shipmentItemLoading = false);
      // 获取已接收库存明细
      this.inventoryReceiptsLoading = true;
      getInventoryReceipts({
        warehouseId: this.warehouseId,
        shipmentId: this.shipmentId
      })
        .then((data) => {
          this.inventoryReceipts = data;
        })
        .complete(() => this.inventoryReceiptsLoading = false);
    },
    methods: {
      handleClick() {
        const vm = this;
        this.$nextTick(() => vm.$nextTick(() => vm.inventoryReceipts = [...vm.inventoryReceipts]));
      },
      viewFbaPackage(fileId) {
        this.fbaPackageFileDownloadLoading = true;
        downloadAttFile(fileId)
          .complete(() => this.fbaPackageFileDownloadLoading = false);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .content-row {
    line-height: 32px;
    display: flex;
    .gj-label {
      text-align: right;
      color: #666;
      font-size: 12px;
      width: 84px;
    }
    .gj-content{
      color: #333;
      font-size: 12px;
      display: flex;
      flex: 1;
    }
    .content_flex2{
      flex: 2;
    }
    .right-shift_30{
      margin-left: 30px;
    }
  }
  

  /deep/ .gj-tooltip[data-v-3eb29a35] {
    display: flex;
  }
  /deep/ .el-tag.el-tag--mini{
    line-height: 20px;
  }
  /deep/ .el-dialog__body{
    padding-top: 6px;
  }

  /deep/ .el-tabs__item{
     padding: 0 16px;
  }
</style>


